import { useTranslation } from "react-i18next";
import { Code, Map, BookOpen, ExternalLink } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PageSEO } from "@/components/seo/PageSEO";

const cards = [
  {
    key: "validApi",
    icon: Code,
    href: "https://developer.geposit.se/docs/valid-20",
  },
  {
    key: "atlasApi",
    icon: Map,
    href: "https://developer.geposit.se/reference/post_attribute-container-object-type-object-type-1",
  },
  {
    key: "atlasManual",
    icon: BookOpen,
    href: "https://developer.geposit.se/docs/atlas-intro",
  },
];

export default function Developer() {
  const { t } = useTranslation();

  return (
    <>
      <PageSEO
        title={t("developer.title")}
        description={t("seo.developer")}
      />

      {/* Hero */}
      <section className="py-16 md:py-24 bg-muted/30">
        <div className="container mx-auto px-4 text-center max-w-3xl">
          <h1 className="font-display text-4xl md:text-5xl font-bold text-foreground mb-4">
            {t("developer.title")}
          </h1>
          <p className="text-lg text-muted-foreground">
            {t("developer.subtitle")}
          </p>
        </div>
      </section>

      {/* Cards */}
      <section className="py-16 md:py-20">
        <div className="container mx-auto px-4">
          <div className="grid gap-8 md:grid-cols-3 max-w-5xl mx-auto">
            {cards.map(({ key, icon: Icon, href }) => (
              <Card key={key} className="flex flex-col">
                <CardHeader>
                  <div className="mb-3 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary">
                    <Icon className="h-6 w-6" />
                  </div>
                  <CardTitle className="text-xl">
                    {t(`developer.cards.${key}.title`)}
                  </CardTitle>
                  <CardDescription>
                    {t(`developer.cards.${key}.description`)}
                  </CardDescription>
                </CardHeader>
                <CardContent className="flex-1" />
                <CardFooter>
                  <Button asChild className="w-full gap-2">
                    <a href={href} target="_blank" rel="noopener noreferrer">
                      {t(`developer.cards.${key}.cta`)}
                      <ExternalLink className="h-4 w-4" />
                    </a>
                  </Button>
                </CardFooter>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
